import { gfmTable } from 'micromark-extension-gfm-table'
import { gfmTableFromMarkdown } from 'mdast-util-gfm-table'
import type { Processor } from 'unified'

// `unified`'s own `Data` only declares `settings`; the extension slots are added by a `remark-parse` module
// augmentation that is not guaranteed to be in the type graph here.
type ExtensionData = {
  micromarkExtensions?: unknown[]
  fromMarkdownExtensions?: unknown[]
}

/**
 * Enables GFM tables only, instead of the full `remark-gfm` preset. `remark-gfm` pulls in
 * `mdast-util-gfm-autolink-literal`, whose email regex uses a lookbehind. Regex literals are validated at parse
 * time, so Safari < 16.4 throws a SyntaxError for the whole chunk instead of just that module, taking down every
 * page that shares it.
 *
 * Not an arrow function because unified hands the processor to a plugin through `this`.
 */
// oxlint-disable-next-line func-style
function remarkGfmTable(this: Processor) {
  const data = this.data() as ExtensionData

  const micromarkExtensions = (data.micromarkExtensions ??= [])
  const fromMarkdownExtensions = (data.fromMarkdownExtensions ??= [])

  micromarkExtensions.push(gfmTable())
  fromMarkdownExtensions.push(gfmTableFromMarkdown())
}

export default remarkGfmTable
